<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2020-11-25 03:12:26
    Description : 矩阵切片图片浏览器, 来源于krpano
  -->
  <el-dialog
    custom-class="dialog"
    :visible.sync="dialogVisible"
    :show-close="false"
    :width="width"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    @open="dialogOpen"
  >
    <div id="wrapper">
      <div id="pano" @dblclick="krpano.call(`set(fullscreen,true)`)"></div>
    </div>
    <div
      class="nav-bar"
      :class="{ hidden: !navbarShow }"
      @mouseenter="clearNavbarEvent()"
      @mouseleave="closeNavbarEvent"
    >
      <a
        href="#"
        @mousedown="krpano.call(`set(fov_moveforce,-1)`)"
        @mouseup="krpano.call(`set(fov_moveforce,0)`)"
        @mouseenter="fill[0].value = '#fff'"
        @mouseleave="fill[0].value = '#ddd'"
      >
        <el-tooltip effect="dark" placement="bottom" content="放大">
          <zoom-in theme="outline" size="24" :fill="fill[0].value" />
        </el-tooltip>
      </a>
      <a
        href="#"
        @mousedown="krpano.call(`set(fov_moveforce,1)`)"
        @mouseup="krpano.call(`set(fov_moveforce,0)`)"
        @mouseenter="fill[1].value = '#fff'"
        @mouseleave="fill[1].value = '#ddd'"
      >
        <el-tooltip effect="dark" placement="bottom" content="缩小">
          <zoom-out theme="outline" size="24" :fill="fill[1].value" />
        </el-tooltip>
      </a>
      <a
        href="#"
        @click="krpano.call(`set(fullscreen,true)`)"
        @mouseenter="fill[2].value = '#fff'"
        @mouseleave="fill[2].value = '#ddd'"
      >
        <el-tooltip effect="dark" placement="bottom" content="全屏浏览">
          <full-screen-one
            theme="outline"
            size="24"
            fill="#ddd"
            :fill="fill[2].value"
          />
        </el-tooltip>
      </a>
      <a
        href="#"
        @click="oriSize"
        @mouseenter="fill[3].value = '#fff'"
        @mouseleave="fill[3].value = '#ddd'"
      >
        <el-tooltip effect="dark" placement="bottom" content="快速缩小">
          <one-to-one
            theme="outline"
            size="24"
            fill="#ddd"
            :fill="fill[3].value"
          />
        </el-tooltip>
      </a>
      <a href="#" @click="dialogVisible = false">
        <el-tooltip effect="dark" placement="bottom" content="关闭">
          <close theme="outline" size="24" fill="#ddd" />
        </el-tooltip>
      </a>
    </div>
  </el-dialog>
</template>
<script>
import {
  FullScreenOne,
  OneToOne,
  ZoomIn,
  ZoomOut,
  Close,
} from "@icon-park/vue";
export default {
  name: "gaia-imgViewer",
  components: {
    FullScreenOne,
    OneToOne,
    ZoomIn,
    ZoomOut,
    Close,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    xml: {
      type: String,
      default: "",
    },
  },
  watch: {
    show(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit("close");
      }
    },
  },
  data() {
    return {
      dialogVisible: false,
      width: "1000px",
      krpano: null,
      isFullScreen: false,
      navbarShow: true,
      closeNavbar: null,
      fill: [
        { value: "#ddd" },
        { value: "#ddd" },
        { value: "#ddd" },
        { value: "#ddd" },
        { value: "#ddd" },
      ],
    };
  },
  mounted() {},
  methods: {
    test() {
      console.log("test");
    },
    fullScreen() {
      this.krpano.call(`set(fullscreen,true)`);
    },
    dialogOpen() {
      const xml = this.xml;
      this.navbarShow = true;
      setTimeout(() => {
        embedpano({
          xml: xml,
          target: "pano",
          mobilescale: 1.0,
          passQueryParameters: true,
          bgcolor: "#dddddd",
        });
        this.krpano = document.getElementById("krpanoSWFObject");
      }, 0);
    },
    closeNavbarEvent() {
      this.closeNavbar = setTimeout(() => {
        this.navbarShow = false;
      }, 2000);
    },
    clearNavbarEvent() {
      this.navbarShow = true;
      clearTimeout(this.closeNavbar);
    },
    oriSize() {
      this.krpano.call(`set(fov_moveforce,1)`);
      setTimeout(() => {
        this.krpano.call(`set(fov_moveforce,0)`);
      }, 800);
    },
  },
};
</script>
<style lang="less">
</style>
<style lang="less" scoped>
#wrapper,
#pano {
  width: 100%;
  height: 100%;
}

.nav-bar {
  position: absolute;
  display: flex;
  align-items: center;
  bottom: 20px;
  left: 0;
  right: 0;
  width: 300px;
  height: 50px;
  border-radius: 25px;
  padding: 0 25px;
  margin: auto;
  background: rgba(0, 0, 0, 0.4);
  transition: all 0.6s;
  a {
    display: block;
    width: 10%;
    margin: 0 5.34%;
    text-align: center;
    outline: none;
    cursor: pointer;
  }
}
.nav-bar.hidden {
  opacity: 0;
  transition: all 0.6s;
}
</style>

